import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Wrapper = styled.aside`
  display: flex;

  grid-column: 1 / -1;
  margin: 0 16px 32px;

  background-color: ${colors.white};

  ${mediaDesktop(`
    position: absolute;
    left: 0;
    bottom: -32px;
    transform: translateY(100%);
    max-width: 242px;
    flex-direction: column;
    margin: 0 0 32px 124px;
    grid-column: 1 / 4;
  `)}
`;

export const Avatar = styled.img`
  display: none;
  width: 86px;
  height: 86px;
  object-fit: cover;

  margin-bottom: 16px;

  ${mediaDesktop(`
    display: block;
  `)}
`;

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div``;

export const Label = styled.span`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
  color: ${colors.dustyGray};
`;

export const Value = styled.span`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
`;

export const Bio = styled.p`
  display: none;
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
  margin-top: 8px;
  color: ${colors.dustyGray};

  ${mediaDesktop(`
    display: block;
  `)}
`;
